import { storage } from '@newo/storage';
import { create } from 'zustand';
import { persist, type StorageValue } from 'zustand/middleware';

type IAppFields = {
	businessSource?: string | null;
	resetState: () => void;
	setBusinessSource: (businessSource: string | null) => void;
};

const initialState = {
	businessSource: null
};

const useAppStore = create<IAppFields>()(
	persist(
		(set) => ({
			...initialState,
			resetState: () =>
				set({
					businessSource: null
				}),
			setBusinessSource: (businessSource) => {
				set({ businessSource });
			}
		}),
		{
			name: 'app-store',
			storage: {
				getItem: (key) => storage.get<StorageValue<IAppFields>>(key),
				setItem: (key, value) => storage.set(key, value),
				removeItem: (key) => storage.remove(key)
			},
			partialize: (state) => state,
			version: 1
		}
	)
);

export default useAppStore;
